module.exports = __webpack_public_path__ + "img/gotomarker_left_mod.37bb66ca.svg";